/**
 * 用社区框架打开页面
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import { absUrl } from '@common/host'
import { call, uriSuishouji } from './bridge'

/**
 * url: 唤醒地址
 */
export default (_url) => {
  const url = absUrl(_url)
  if (useragent.isSuishouji) {
    call(uriSuishouji('requestBBS', { url }))
  } else {
    window.location.href = url
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestBBS.js